<button mat-raised-button [matMenuTriggerFor]="pickerMenu" #trigger="matMenuTrigger" [ngClass]="{ 'custom-style': customStyle, 'disabled-field': disabledField }" class="icon-color-button" [class.read-only]="readOnlyMode"  [disabled]="readOnlyMode">
  <div class="button-content">
    <div class="icon-box" [ngStyle]="{ 'background-color': selectedColor || '#fff' }"   
    [ngClass]="{
       'half-left': shiftType === 'FIRST_HALF_DAY_DUTY',
       'half-right': shiftType === 'SECOND_HALF_DAY_DUTY',
       'full-day': shiftType === 'FULL_DAY_DUTY'
    }">
      
      <!-- If custom text exists, show it with its color -->
      <ng-container *ngIf="customIconForm.get('customText')?.value?.trim() || customIconForm.get('iconType')?.value == 'text'; else svgIcon">
        <span [ngStyle]="{ color: customIconForm.get('customTextColor')?.value }">
          {{customIconForm.get('customText')?.value}}
        </span>
      </ng-container>

      <!-- Else fallback to SVG -->
      <ng-template #svgIcon>
        <ng-container *ngIf="selectedIcon; else emptyBox">
          <svg width="20" height="20" viewBox="0 0 24 24">
            <use [attr.xlink:href]="'#' + selectedIcon"></use>
          </svg>
        </ng-container>
      </ng-template>

      <ng-template #emptyBox></ng-template>
    </div>
    <mat-icon class="dropdown-arrow" *ngIf="!readOnlyMode">arrow_drop_down</mat-icon>
  </div>
</button>

<mat-menu #pickerMenu="matMenu" class="picker-menu" [hasBackdrop]="true" [overlapTrigger]="false" cdkTrapFocus="false">
    <ng-template matMenuContent>
        <div class="orgApp-picker-container" (click)="$event.stopPropagation()">
            <mat-tab-group [(selectedIndex)]="tabIndex" animationDuration="0ms">
                <mat-tab label="Icons">
                    <div class="icon-grid">
                        <button
                        mat-icon-button
                        *ngFor="let icon of icons"
                        [class.selected]="icon === selectedIcon"
                        (click)="onIconClick(icon); $event.stopPropagation()"
                        >
                        <svg width="24" height="24">
                            <use [attr.xlink:href]="'#' + icon"></use>
                        </svg>
                        </button>
                    </div>
                </mat-tab>
                <mat-tab label="Colors">
                    <div class="color-grid">
                        <button
                        *ngFor="let color of colors"
                        class="color-btn"
                        [ngStyle]="{ 'background-color': color }"
                        [class.selected]="color === selectedColor"
                        (click)="onColorClick(color)"
                        >

                        <ng-container *ngIf="customIconForm.get('customText')?.value; else iconPreview">
                            <span
                                [ngStyle]="{
                                    color:  customIconForm.get('customTextColor')?.value,
                                    'font-weight': 'bold',
                                    'font-size': '14px'
                                }"
                            >
                                {{ customIconForm.get('customText')?.value }}
                            </span>
                        </ng-container>

                        <ng-template #iconPreview>
                            <ng-container *ngIf="selectedIcon">
                                <svg width="16" height="16" viewBox="0 0 24 24">
                                    <use [attr.xlink:href]="'#' + selectedIcon"></use>
                                </svg>
                            </ng-container>
                        </ng-template>
                        <!-- <ng-container *ngIf="selectedIcon">
                            <svg width="16" height="16" viewBox="0 0 24 24">
                            <use [attr.xlink:href]="'#' + selectedIcon"></use>
                            </svg>
                        </ng-container> -->
                        </button>
                        <!-- Custom color picker -->
                        <button
                            class="color-picker-btn"
                            [style.background]="'#ffffff'"
                            [colorPicker]="selectedColor"
                            [cpAlphaChannel]="'always'"
                            [cpOutputFormat]="'hex'"
                            [cpPosition]="'bottom'"
                            [cpDialogDisplay]="'popup'"
                            [cpUseRootViewContainer]="true"
                            (colorPickerSelect)="onColorClick($event)"
                            (click)="$event.stopPropagation()"
                        >
                            <mat-icon>colorize</mat-icon>
                        </button>
                    </div>
                </mat-tab>
            </mat-tab-group>
            <div class="picker-footer orgApp-d-flex orgApp-justify-c-spc-btw orgApp-align-i-center orgApp-padding-left-12 orgApp-padding-right-12">  
                   
                <form [formGroup]="customIconForm" class="custom-icon-tab">
                    <div class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center">
                    <mat-form-field floatLabel="always" appearance="outline"  class="orgApp-icon-text-field orgApp-input-field orgApp-field-rounded-sm orgApp-field-border-color">
                        <input [ngStyle]="{ color: customIconForm.get('customTextColor')?.value }"
                            matInput
                            formControlName="customText"
                            maxlength="3"
                            placeholder="Icon Text"
                        />
                        <!-- Show clear/close icon only if there is a value -->
                        <span class="orgApp-clear-text-icon" *ngIf="customIconForm.get('customText')?.value" 
                            matSuffix 
                            aria-label="Clear"
                            (click)="customIconForm.get('customText')?.setValue(''); customIconForm.get('customTextColor')?.setValue('#000000'); iconType='svg';">
                        <mat-icon>close</mat-icon>
                    </span>
                    </mat-form-field>

                    <!-- Text Color Picker -->
                    <button class="color-picker-btn format-text-color-btn"
                        [style.background]="customIconForm.get('customTextColor')?.value ? customIconForm.get('customTextColor')?.value + '80' : '#fff'"
                        [colorPicker]="customIconForm.get('customTextColor')?.value"
                        [cpAlphaChannel]="'always'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'bottom'"
                        [cpDialogDisplay]="'popup'"
                        [cpUseRootViewContainer]="true" (colorPickerSelect)="onTextColorClick($event)"
                        (colorPickerSelect)="customIconForm.get('customTextColor')?.setValue($event)">
                            <mat-icon>format_color_text</mat-icon>
                    </button>
                    </div>
                </form>

                <!-- Close Button -->
                <button class="icon-selection-close-btn" mat-icon-button color="primary" (click)="closeMenu()"> <mat-icon>close</mat-icon></button>
               
            </div>
        </div>
    </ng-template>
</mat-menu>
